import React from 'react'
import styled from 'styled-components'
import dai from '../../assets/currencies/dai.svg'
import eth from '../../assets/currencies/eth.svg'
import unknown from '../../assets/currencies/unknown.svg'
import usdc from '../../assets/currencies/usdc.svg'
import usdt from '../../assets/currencies/usdt.svg'
import itgr from '../../assets/currencies/itgr.svg'
import itgrLp from '../../assets/currencies/itgr-lp.svg'
import wbtc from '../../assets/currencies/wbtc.svg'
import weth from '../../assets/currencies/weth.svg'
import link from '../../assets/currencies/link.svg'
import { INTEGRAL_SYMBOL, INTEGRAL_LP_SYMBOL } from '../../constants'

interface Props {
  className?: string
  symbol: string
}

export function CurrencySymbolImage({ className, symbol }: Props) {
  return <Image className={className} src={imageForSymbol(symbol)} />
}

const Image = styled.img`
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
`

function imageForSymbol(symbol: string) {
  switch (symbol) {
    case 'DAI':
      return dai
    case 'ETH':
    case 'KETH':
    case 'GETH':
      return eth
    case 'USDC':
      return usdc
    case 'USDT':
      return usdt
    case INTEGRAL_SYMBOL:
      return itgr
    case INTEGRAL_LP_SYMBOL:
      return itgrLp
    case 'WBTC':
      return wbtc
    case 'LINK':
      return link
    case 'WETH':
      return weth
  }
  return unknown
}
